module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-ace.916c64e9.svg";